import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_auth/automations')({
  component: RouteComponent,
  loader: async () => {
    // Check if automations are enabled
    const enableAutomations = localStorage.getItem('enableAutomations') === 'true';
    if (!enableAutomations) {
      throw redirect({
        to: '/home/integrations',
      });
    }
    return {};
  },
});

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/home/automations' });
  }, [navigate]);

  return null;
}
